document.addEventListener("DOMContentLoaded", function() {
    // Select your sticky header
    var header = document.querySelector(".header-sticky");
    var accouncement_bar = document.querySelector(".announcement-bar");
    var className = "scroll-active";

    if (!header) return; // exit if header not found

    // Function to toggle class
    function toggleScrollClass() {
        if (window.scrollY > 0) {
            header.classList.add(className);
            accouncement_bar.classList.add(className);
        } else {
            header.classList.remove(className);
            accouncement_bar.classList.remove(className);
        }
    }

    // Listen to scroll
    window.addEventListener("scroll", toggleScrollClass);

    // Trigger once on page load in case already scrolled
    toggleScrollClass();
});

